import React, { useEffect, useRef, useState } from 'react'
import './index.less'
import { Footer } from '@/components/Footer'
import { Header } from '@/components/Header'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { PaintingCard } from '@/components/PaintingCard'
import { useNavigate } from 'react-router-dom'
import { setShowAuthorId } from '@/features/SetShowAuthorId/setShowAuthorId'
import { ancient, museum, RightArrow, upArrow } from '@/assets/images'
import type { UploadProps } from 'antd'
import { Input, message, Popover, Upload } from 'antd'
import {
  CameraOutlined,
  CloseOutlined,
  InboxOutlined,
  RightOutlined,
  SearchOutlined
} from '@ant-design/icons'
import { getImgsInfoByImgID, getSearchInfo, searchMind, SRC_URL } from '@/server'
import { AI_PREDICTION_URL } from '@/server/apiConfig'
import { setToken } from '@/features/Login/login'
import {
  setInfoKey,
  setInfoValue,
  setShowType
} from '@/features/SetIndexSecondInfo/setIndexSecondInfo'
import axios from 'axios'
import AdvancedSearch from '../IndexPage/AdvancedSearch'

const { Dragger } = Upload

export function SearchResultPage() {
  // redux获取token
  const token = useAppSelector((state) => state.login.token)
  // 以图搜图功能模块显示
  const [cameraDisplay, setCameraDisplay] = useState<boolean>(false)
  // redux配置
  const dispatch = useAppDispatch()
  // react-router配置
  const navigate = useNavigate()
  // 输入框内容受控
  const [searchInputText, setSearchInputText] = useState('')
  // 吸顶图标显隐控制
  const [topDisplay, setTopDisplay] = useState(false)
  // card信息
  const [cardInfo, setCardInfo] = useState<any>({})
  // card类型：Author, Work, Inst
  const [cardType, setCardType] = useState<string>('')
  // 搜索关键字
  const [searchKey, setSearchKey] = useState<string>(useAppSelector((state) => state.searchKey.key))
  // 每次加载画作数量
  const paintingsSize = 21
  // 距离底部多少像素时预加载下一页
  const loadMoreDistance = 600
  // 搜索框列表
  const [searchList, setSearchList] = useState<any[]>([])
  // 实际键入内容
  const [exactInputText, setExactInputText] = useState('')
  // 当前选中的搜索条目idx
  const [activatedIndex, setActivatedIndex] = useState<number>(-1)
  // 搜索列表发生变化不选中任何条目
  useEffect(() => {
    setActivatedIndex(-1)
  }, [searchList])
  // 是否需要展示高亮条目
  const [activatedShowed, setActivatedShowed] = useState<boolean>(false)
  // 以图搜图功能上传图片
  const [imgFile, setImgFile] = useState<any>(useAppSelector((state) => state.searchKey.imgFile))
  // 以图搜图结果
  const [imgFileList, setImgFileList] = useState<any>(
    useAppSelector((state) => state.searchKey.imgsList)
  )
  // 搜图结果历史
  const [imgResultHistory, setImgResultHistory] = useState<any[]>([])
  // 搜图文件历史
  const [imgFileHistory, setImgFileHistory] = useState<any[]>([])
  // 搜图hashIndex
  const [searchImgHashIdx, setSearchImgHashIdx] = useState<number>(0)
  // 监听hash是否为特征值"*SEARCH-IMAGE*"，若是，展示对应模块
  useEffect(() => {
    if (searchKey === '*SEARCH-IMAGE*') {
      //@ts-ignore
      document.getElementById('upload-preview-image')?.setAttribute('src', imgFile)
      setCameraDisplay(true)
    }
  }, [imgFile])

  // card展示与否
  const [cardShowed, setCardShowed] = useState<boolean>(false)
  // 展示内容列表
  const [showList, setShowList] = useState<any>([])
  // 当前加载到的页码
  const [page, setPage] = useState<number>(1)
  // 总页码数
  const [total, setTotal] = useState<number>(0)
  // 是否正在请求数据，避免滚动时重复触发
  const [loading, setLoading] = useState<boolean>(false)
  // 搜索用时
  const [searchTime, setSearchTime] = useState(0)
  // 是否使用高级搜索
  const [useAdvancedSearch, setUseAdvancedSearch] = useState<boolean>(false)
  // 显示搜索框内容
  const [showInput, setShowInput] = useState<boolean>(false)
  // 储存定时器id
  const tickRef = useRef()
  // 超三位数字每三位加逗号
  function NumWithComma(number) {
    const reg = /(\d)(?=(?:\d{3})+$)/g
    return number.toString().replace(reg, '$1,')
  }
  // card点击回调，跳转相应详情页
  function handleCardClick() {
    switch (cardType) {
      case 'Author':
        dispatch(setShowAuthorId(cardInfo.authorid))
        // navigate("/author")
        window.open('/author')
        break
      case 'Work':
        // dispatch(setShowWorkId(cardInfo.workid))
        // navigate("/details")
        // window.open("/details")
        window.open('/details/' + cardInfo.workid + '/null')
        break
      case 'Inst':
        dispatch(setShowType('painting'))
        dispatch(setInfoKey('institute'))
        dispatch(setInfoValue(cardInfo.instnamech))
        // navigate("/indexSecond")
        window.open('/indexSecond')
        break
    }
  }
  // 搜索结果点击回调，改变url的hash，更新页面内容
  function handleSearchItemClick(e) {
    window.location.hash = e.target.innerText
    setSearchList([])
    setSearchInputText(e.target.innerText)
  }
  // 搜索结果回车回调，改变url的hash，更新页面内容
  function handlePressEnter(e) {
    window.location.hash = e.target.value
    setSearchList([])
    setSearchInputText(e.target.value)
  }
  // 高级搜索的回调
  function handleAdvancedSearch(keyWord: string) {
    window.location.hash = keyWord
    setSearchList([])
    setSearchInputText(keyWord)
    setUseAdvancedSearch(false)
  }
  // 监听hash改变searchKey
  window.onhashchange = function (e) {
    if (e.newURL.indexOf('#') !== -1) {
      // 搜索文字内容
      if (e.newURL.indexOf('*SEARCH-IMAGE*') === -1) {
        // decodeURI中文解码
        setSearchKey(decodeURI(e.newURL.slice(e.newURL.indexOf('#') + 1)))
        setSearchInputText(decodeURI(e.newURL.slice(e.newURL.indexOf('#') + 1)))
        setCameraDisplay(false)
      }
      // 以图搜图
      else {
        setTotal(0)
        setCardShowed(false)
        setCameraDisplay(true)
        const idx = e.newURL.slice(e.newURL.indexOf('*SEARCH-IMAGE*') + '*SEARCH-IMAGE*'.length)
        if (idx < imgFileHistory.length) {
          setSearchInputText('')
          document.getElementById('upload-preview-image')?.setAttribute('src', imgFileHistory[idx])
          Promise.all(
            Object.keys(imgResultHistory[idx]).map((imageId) =>
              getImgsInfoByImgID(token, {
                imageId
              })
            )
          ).then((res) => {
            if (res[0].data.code === '10056') {
              //token失效
              window.confirm('登录已过期，请重新登录！')
              dispatch(setToken(''))
              navigate('/')
            } else setShowList(res.map((workInfo) => workInfo.data.content))
          })
        }
      }
    }
  }
  /**
   * 柯里化函数，返回fun的防抖版本，即触发fun后delay时间段才生效，此时间段内再次触发则重新计时
   * @param fun: 功能函数
   * @param delay: 时间阈值
   * @returns function fun的防抖版本
   */
  function debounce(fun, delay) {
    return function (_args) {
      //@ts-ignore
      const that = this
      clearTimeout(tickRef.current)
      //@ts-ignore
      tickRef.current = setTimeout(function () {
        fun.call(that, _args)
      }, delay)
    }
  }
  // 获取搜索联想匹配的列表
  function ajax(content) {
    searchMind(
      {
        keyword: content
      },
      token
    ).then((res) => {
      setSearchList(res.data.content)
    })
  }
  // function ajax 的防抖版本
  const debounceAjax = debounce(ajax, 500)
  // 处理搜索框内容变化的回调
  const handleSearchBoxChange = (e: any) => {
    setExactInputText(e.target.value)
    setSearchInputText(e.target.value)
    if (e.target.value === '') {
      setSearchList([])
    } else {
      debounceAjax(e.target.value)
    }
  }

  // 处理搜索框上下按键高亮搜索条目
  // 只有上下按键改变输入框的值，hover不改变，setSearchInputText不再单独写出来
  function handleUpDown(e) {
    // 下
    if (e.keyCode === 40) {
      if (activatedIndex === searchList.length - 1) {
        setActivatedIndex(-1)
        setSearchInputText(exactInputText)
      } else if (activatedIndex === searchList.length) {
        setActivatedIndex(0)
        setSearchInputText(searchList[0])
      } else {
        setActivatedIndex(activatedIndex + 1)
        setSearchInputText(searchList[activatedIndex + 1])
      }
    }
    // 上
    else if (e.keyCode === 38) {
      if (activatedIndex === 0) {
        setActivatedIndex(searchList.length)
        setSearchInputText(exactInputText)
      } else if (activatedIndex === -1) {
        setActivatedIndex(searchList.length - 1)
        setSearchInputText(searchList[searchList.length - 1])
      } else {
        setActivatedIndex(activatedIndex - 1)
        setSearchInputText(searchList[activatedIndex - 1])
      }
    }
  }

  // 点击搜索框外部自动隐藏搜索列表
  useEffect(() => {
    const func = () => {
      // @ts-ignore
      document.getElementById('searchListContainer').style.display = 'none'
    }
    document.addEventListener('click', func)
    return () => {
      document.removeEventListener('click', func)
    }
  }, [])

  function handleSearchBoxClick(e) {
    // 禁止冒泡，阻止自动隐藏列表事件
    if (e.stopPropagation) {
      e.stopPropagation()
    } else {
      const event = e as any
      event.cancelBuble = true
    }
    if (searchList.length > 0)
      // @ts-ignore
      document.getElementById('searchListContainer').style.display = 'block'
  }
  /**
   * 获取数据
   * @param init: 是否初始化，一些状态需要重置，默认不切换
   * @returns
   */
  function appendData(init = false) {
    if (!init && loading) return
    setLoading(true)

    getSearchInfo(
      {
        keyword: searchKey,
        pages: {
          page: init ? 1 : page,
          size: paintingsSize
        }
      },
      token
    )
      .then((res) => {
        setShowList((prevShowList) =>
          init ? res.data.content.work.list : [...prevShowList, ...res.data.content.work.list]
        )
        setTotal(res.data.content.work.total)
        // init为true处理card
        if (init) {
          setSearchTime(res.data.time / 1000)
          if (Object.keys(res.data.content.card).length !== 0) {
            setCardShowed(true)
            setCardInfo(res.data.content.card.value)
            setCardType(res.data.content.card.type)
          } else {
            setCardShowed(false)
          }
        }
        setPage(init ? 2 : page + 1)
      })
      .finally(() => setLoading(false))
  }

  // 初始加载 page === 1 的数据
  useEffect(() => {
    // 以图搜图
    if (searchKey === '*SEARCH-IMAGE*') {
      setTotal(0)
      Promise.all(
        Object.keys(imgFileList).map((imageId) =>
          getImgsInfoByImgID(token, {
            imageId
          })
        )
      ).then((res) => {
        if (res[0].data.code === '10056') {
          //token失效
          window.confirm('登录已过期，请重新登录！')
          dispatch(setToken(''))
          navigate('/')
        } else setShowList(res.map((workInfo) => workInfo.data.content))
      })
    }
    // 文字搜索
    else {
      window.location.hash = searchKey
      setSearchInputText(searchKey)
      appendData(true)
    }
  }, [])
  // 监听以图搜图搜索结果改变，更新相应参数
  useEffect(() => {
    if (searchKey === '*SEARCH-IMAGE*') {
      window.location.hash = '*SEARCH-IMAGE*' + String(searchImgHashIdx)
      setImgResultHistory([...imgResultHistory, imgFileList])
      //@ts-ignore
      setImgFileHistory([...imgFileHistory, imgFile])
      setSearchImgHashIdx(searchImgHashIdx + 1)
      setTotal(0)
      setCardShowed(false)
      // setCameraDisplay(false)
      Promise.all(
        Object.keys(imgFileList).map((imageId) =>
          getImgsInfoByImgID(token, {
            imageId
          })
        )
      ).then((res) => {
        if (res[0].data.code === '10056') {
          //token失效
          window.confirm('登录已过期，请重新登录！')
          dispatch(setToken(''))
          navigate('/')
        } else setShowList(res.map((workInfo) => workInfo.data.content))
      })
    }
  }, [imgFileList])
  // 监听searchKey改变，更新内容
  useEffect(() => {
    if (searchKey !== '*SEARCH-IMAGE*') {
      appendData(true)
      setCameraDisplay(false)
      //@ts-ignore
      document.getElementById('upload-preview-image')?.setAttribute('src', '')
    }
  }, [searchKey])
  /**
   * 柯里化函数，封装节流功能，在delay时间段内，fun只能执行一次
   * @param fun: 被封装的函数
   * @param delay: 时间阈值
   * @returns function 节流版本的fun
   */
  function throttle(fun, delay) {
    let last
    return function () {
      //@ts-ignore
      const that = this
      const _args = arguments
      const now = +new Date()
      if (last && now < last + delay) {
        // clearTimeout(throttleRef.current)
        // //@ts-ignore
        // throttleRef.current = setTimeout(function () {
        //   last = now
        //   fun.apply(that, _args)
        // }, delay)
      } else {
        last = now
        fun.apply(that, _args)
      }
    }
  }
  useEffect(() => {
    // 500ms的节流版appendData
    const throttleAjax = throttle(appendData, 500)
    // 监听页面滚动高度，触发加载数据函数以及吸顶图标显隐
    const handleScroll = function () {
      const scrollElement = document.body
      // 真实内容高度
      const pageHeight = scrollElement.scrollHeight
      // 视窗高度
      const viewportHeight = scrollElement.clientHeight || window.innerHeight || 0
      // 上面隐藏的高度
      const scrollHeight = scrollElement.scrollTop
      const distanceToBottom = pageHeight - viewportHeight - scrollHeight
      const hasMore = searchKey !== '*SEARCH-IMAGE*' && showList.length < total
      // 通过 真实内容高度 - 视窗高度 - 上面隐藏的高度 < 某阈值，作为加载下一页数据的触发条件
      if (distanceToBottom >= 0 && distanceToBottom <= loadMoreDistance && hasMore && !loading) {
        throttleAjax()
      }
      if (scrollHeight > 1500) {
        setTopDisplay(true)
      } else {
        setTopDisplay(false)
      }
    }
    document.body.addEventListener('scroll', handleScroll)
    return () => {
      document.body.removeEventListener('scroll', handleScroll)
    }
  }, [page, total, searchKey, token, showList.length, loading])
  // 以图搜图 antd upload配置
  const props: UploadProps = {
    showUploadList: false,
    maxCount: 1,
    accept: 'image/png, image/jpeg, image/jpg',
    // 自定义上传方式
    customRequest: (info) => {
      // 设置上传图片最大容量5MB
      const fileMaxSize = 5 << 20
      // @ts-ignore
      if (info.file.size <= fileMaxSize) {
        axios
          .post(
            AI_PREDICTION_URL,
            { data: info.file },
            {
              headers: { 'Content-Type': 'multipart/form-data' }
            }
          )
          .then((res) => {
            setImgFileList(res.data)
            setSearchKey('*SEARCH-IMAGE*')
            //@ts-ignore
            setImgFile(URL.createObjectURL(info.file))
          })
          .catch((err) => {
            console.log(err)
          })
      } else message.error('对不起, 上传图片容量不得超过5MB')
    }
  }

  return (
    <>
      <div className='searchResult-page-container'>
        <div
          className='back-to-top'
          onClick={() => (document.body.scrollTop = 0)}
          style={{ visibility: topDisplay ? 'visible' : 'hidden' }}
        >
          <img src={upArrow} alt='up-to-top'></img>
        </div>
        <div className='header-container'>
          <Header />
        </div>

        <div className='searchResult-content-container'>
          <div className='advanced-search-trigger'>
            <span
              onClick={() => {
                setUseAdvancedSearch(!useAdvancedSearch)
              }}
              style={{ cursor: 'pointer' }}
            >
              高级搜索
            </span>
            <RightOutlined />
          </div>
          <div className='search-bar-container'>
            {useAdvancedSearch ? (
              <AdvancedSearch handleSearchKeyWord={handleAdvancedSearch}></AdvancedSearch>
            ) : (
              <Popover
                placement='bottom'
                title=''
                content={searchInputText}
                open={showInput && searchInputText !== ''}
              >
                <Input
                  id='search-box'
                  placeholder={'输入搜索关键字'}
                  value={searchInputText}
                  onChange={(e) => handleSearchBoxChange(e)}
                  onPressEnter={(e) => handlePressEnter(e)}
                  prefix={<SearchOutlined />}
                  suffix={
                    <CameraOutlined
                      onClick={() => setCameraDisplay(true)}
                      style={{ display: cameraDisplay ? 'none' : 'block' }}
                    />
                  }
                  bordered={false}
                  onClick={(e) => handleSearchBoxClick(e)}
                  onKeyDown={(e) => {
                    setActivatedShowed(true)
                    handleUpDown(e)
                  }}
                  onMouseOver={() => {
                    setShowInput(true)
                  }}
                  onMouseOut={() => {
                    setShowInput(false)
                  }}
                  autoComplete='off'
                  style={{
                    width: '100%',
                    height: '100%',
                    // backgroundColor: "#FFFFFF",
                    // borderRadius: "0px",
                    // color: "#725C2A",
                    fontSize: '20px'
                  }}
                />
              </Popover>
            )}

            <div
              className='search-item-container'
              id='searchListContainer'
              onMouseEnter={() => setActivatedShowed(true)}
              onMouseLeave={() => setActivatedShowed(false)}
              style={{ display: searchList.length > 0 ? 'block' : 'none' }}
            >
              {searchList.map((d, i) => (
                <div
                  className={
                    i === activatedIndex && activatedShowed
                      ? 'search-item search-item-activated'
                      : 'search-item'
                  }
                  onClick={(e) => handleSearchItemClick(e)}
                  onMouseOver={() => {
                    setActivatedIndex(i)
                  }}
                  style={{ display: cameraDisplay === false ? 'block' : 'none' }}
                >
                  {d}
                </div>
              ))}
            </div>
            <div
              className='upload-container'
              id='upload-container'
              style={{ display: cameraDisplay === true ? 'block' : 'none' }}
            >
              <Dragger {...props}>
                <p className='ant-upload-drag-icon'>
                  <InboxOutlined style={{ color: '#725c2a' }} />
                </p>
                <p className='ant-upload-text' style={{ fontSize: '20px' }}>
                  拖拽图片到这里或点击上传
                </p>
                <p className='ant-upload-text' style={{ fontSize: '20px' }}>
                  以图搜图
                </p>
                <div className='preview-image-container'>
                  <img src='' alt='' id='upload-preview-image' />
                </div>
              </Dragger>
              <CloseOutlined
                className='close-search-image-button'
                onClick={(e) => {
                  //@ts-ignore
                  if (e.stopPropagation) {
                    e.stopPropagation()
                  } else {
                    const event = e as any
                    event.cancelBuble = true
                  }
                  setCameraDisplay(false)
                }}
              />
            </div>
          </div>
          <div
            className='search-result-container'
            style={{ display: searchKey === '*SEARCH-IMAGE*' ? 'none' : 'block' }}
          >
            找到 {NumWithComma(total + (cardShowed ? 1 : 0))} 条结果 （用时 {searchTime} 秒）
          </div>
          <div
            className='card-container'
            onClick={() => handleCardClick()}
            style={{ display: cardShowed ? 'flex' : 'none' }}
          >
            <div className='image-container'>
              {(() => {
                switch (cardType) {
                  case 'Work':
                    return <img src={`${SRC_URL}${cardInfo.encoding}`} alt={searchKey} />
                  case 'Author':
                    return <img src={`${SRC_URL}${cardInfo.avatarpath}`} alt={searchKey} />
                  case 'Inst':
                    return <img src={`${SRC_URL}${cardInfo.avatarpath}`} alt={searchKey} />
                  default:
                    return null
                }
              })()}
            </div>
            <div className='info-container'>
              <div className='info-title'>
                <div className='info-title-name'>
                  {(() => {
                    switch (cardType) {
                      case 'Author':
                        return cardInfo.authornamecn ?? searchKey
                      case 'Work':
                        return cardInfo.workname ?? searchKey
                      case 'Inst':
                        return cardInfo.instnamech ?? searchKey
                      default:
                        return null
                    }
                  })()}
                </div>
                <div className='info-title-info'>
                  {(() => {
                    switch (cardType) {
                      case 'Author':
                        return `${cardInfo.dynasty ?? ''}${
                          cardInfo.dynasty && cardInfo.birth && cardInfo.death ? '｜' : ''
                        }${
                          cardInfo.birth && cardInfo.death
                            ? `${cardInfo.birth}年-${cardInfo.death}年`
                            : ''
                        }${cardInfo.workNum && cardInfo.birth && cardInfo.death ? '｜' : ''}
                      ${cardInfo.workNum ? `共计${cardInfo.workNum}件作品` : ''}`
                      case 'Inst':
                        return `${cardInfo.addresscontinent ?? ''}${
                          cardInfo.addresscontinent && cardInfo.addresscountry ? '｜' : ''
                        }${cardInfo.addresscountry ? cardInfo.addresscountry : ''}`
                      default:
                        return null
                    }
                  })()}
                </div>
                <div className='info-title-icon'>
                  <img src={RightArrow} alt='rightarrow-icon' />
                </div>
              </div>
              <div className='info-subtitle'>
                {cardType === 'Work' ? (
                  ''
                ) : (
                  <img
                    src={(() => {
                      switch (cardType) {
                        case 'Author':
                          return ancient
                        case 'Inst':
                          return museum
                        default:
                          return undefined
                      }
                    })()}
                    alt='museum-icon'
                    height={20}
                    style={{ marginRight: '10px' }}
                  />
                )}
                <div
                  className='subtitle-content'
                  title={(() => {
                    switch (cardType) {
                      case 'Author':
                        return `${cardInfo.stylename ? '字' + cardInfo.stylename + '，' : ''}${
                          cardInfo.hao ? '号' + cardInfo.hao + '，' : ''
                        }${cardInfo.origin ? cardInfo.origin + '人' : ''}`
                      case 'Work':
                        return `${cardInfo.dynasty ?? ''}${
                          cardInfo.dynasty && cardInfo.authorname ? '｜' : ''
                        }${cardInfo.authorname ?? ''}${
                          cardInfo.authorname && cardInfo.instname ? '｜' : ''
                        }${cardInfo.instname ?? ''}`
                      case 'Inst':
                        return cardInfo.instnameen ?? ''
                      default:
                        return null
                    }
                  })()}
                >
                  {(() => {
                    switch (cardType) {
                      case 'Author':
                        return `${cardInfo.stylename ? '字' + cardInfo.stylename + '，' : ''}${
                          cardInfo.hao ? '号' + cardInfo.hao + '，' : ''
                        }${cardInfo.origin ? cardInfo.origin + '人' : ''}`
                      case 'Work':
                        return `${cardInfo.dynasty ?? ''}${
                          cardInfo.dynasty && cardInfo.authorname ? '｜' : ''
                        }${cardInfo.authorname ?? ''}${
                          cardInfo.authorname && cardInfo.instname ? '｜' : ''
                        }${cardInfo.instname ?? ''}`
                      case 'Inst':
                        return cardInfo.instnameen ?? ''
                      default:
                        return null
                    }
                  })()}
                </div>
              </div>
              <div className='info-splitline'></div>
              <div
                className='info-content'
                title={(() => {
                  switch (cardType) {
                    case 'Author':
                      return cardInfo.introduction ?? ''
                    case 'Work':
                      return cardInfo.description ?? ''
                    case 'Inst':
                      return cardInfo.introduction ?? ''
                    default:
                      return null
                  }
                })()}
              >
                {(() => {
                  switch (cardType) {
                    case 'Author':
                      return cardInfo.introduction ?? ''
                    case 'Work':
                      return cardInfo.description ?? ''
                    case 'Inst':
                      return cardInfo.introduction ?? ''
                    default:
                      return null
                  }
                })()}
              </div>
            </div>
          </div>

          <div className='infocontent-container'>
            {showList.map(
              (item, i) =>
                item && (
                  <PaintingCard
                    title={item.workname}
                    dynasty={item.dynasty}
                    author={item.authorname}
                    museum={item.instname}
                    image={item.encoding}
                    id={item.workid}
                    similarity={
                      searchKey === '*SEARCH-IMAGE*'
                        ? '相似度：' +
                          //@ts-ignore
                          String((Object.values(imgFileList)[i] * 100).toFixed(2)) +
                          '%'
                        : ''
                    }
                  />
                )
            )}
          </div>
          <div
            className='end-line-container'
            style={{
              display: paintingsSize * (page - 1) < total ? 'none' : 'flex'
            }}
          >
            <div className='end-line'></div>
            已经到底了
            <div className='end-line'></div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  )
}
